export default __webpack_public_path__ + "static/media/3.01aeac5c.webp";